import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProposalSubmission.css';

const ProposalSubmission = () => {
  const [formData, setFormData] = useState({
    title: '',
    request_letter_lao: null,
    request_letter_english: null,
    main_proposal_lao: null,
    main_proposal_english: null,
    abstract_lao: null,
    abstract_english: null,
    questionnaires_lao: null,
    questionnaires_english: null,
    information_sheet_lao: null,
    information_sheet_english: null,
    consent_form_lao: null,
    consent_form_english: null,
    cvs_lao: null,
    cvs_english: null,
    bill_of_payment: null,
  });

  const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api').replace(/\/$/, '');
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((s) => ({ ...s, [name]: files[0] }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('token');
    if (!token) {
      alert('Your session has expired. Please log in again.');
      navigate('/login');
      return;
    }

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value) data.append(key, value);
    });

    const researcherId = localStorage.getItem('researcherId');
    if (researcherId) data.append('researcher_id', researcherId);
    data.append('submission_date', new Date().toISOString());

    try {
      const res = await fetch(`${API_BASE_URL}/proposals/submit`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });

      if (!res.ok) {
        let msg = `Failed to submit proposal (HTTP ${res.status}).`;
        try {
          const body = await res.json();
          if (body?.message) msg = body.message;
          if (body?.error === 'BlockedByPolicy') {
            alert(`${body.message}\n\nYou can request an exception from the sidebar.`);
            navigate('/exception/request');
            return;
          }
        } catch {}
        if (res.status === 401 || res.status === 403) {
          alert('Your session is invalid or expired. Please log in again.');
          navigate('/login');
          return;
        }
        alert(msg);
        return;
      }

      const { proposalId, customId } = await res.json();
      alert(`Proposal submitted successfully! ${customId ? `ID: ${customId}` : ''}`);
      navigate(`/proposal/${proposalId}`);
    } catch (err) {
      console.error('Error submitting proposal:', err);
      alert('Network error while submitting. Please try again.');
    }
  };

   return (
    <div className="proposal-container">
      <h1 className="proposal-header">Submit Your Proposal</h1>
      <form className="proposal-form" onSubmit={handleSubmit}>
        <div className="form-field full-width">
          <label htmlFor="title">Proposal Title</label>
          <input type="text" id="title" name="title" onChange={handleInputChange} required />
        </div>

<h3>Request Letters</h3>
<div className="form-section">
  <div className="form-field file-upload">
    <label>Request Letter (Lao)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="request_letter_lao"
        onChange={handleFileChange}
        accept=".pdf"
        required
      />
      {formData.request_letter_lao && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, request_letter_lao: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.request_letter_lao.name}</small>
        </>
      )}
    </div>
  </div>

  <div className="form-field file-upload">
    <label>Request Letter (English)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="request_letter_english"
        onChange={handleFileChange}
        accept=".pdf"required
      />
      {formData.request_letter_english && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, request_letter_english: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.request_letter_english.name}</small>
        </>
      )}
    </div>
  </div>
</div>

<h3>Main Proposal</h3>
<div className="form-section">
  <div className="form-field file-upload">
    <label>Main Proposal (Lao)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="main_proposal_lao"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.main_proposal_lao && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, main_proposal_lao: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.main_proposal_lao.name}</small>
        </>
      )}
    </div>
  </div>

  <div className="form-field file-upload">
    <label>Main Proposal (English)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="main_proposal_english"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.main_proposal_english && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, main_proposal_english: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.main_proposal_english.name}</small>
        </>
      )}
    </div>
  </div>
</div>

<h3>Abstract</h3>
<div className="form-section">
  <div className="form-field file-upload">
    <label>Abstract (Lao)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="abstract_lao"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.abstract_lao && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, abstract_lao: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.abstract_lao.name}</small>
        </>
      )}
    </div>
  </div>

  <div className="form-field file-upload">
    <label>Abstract (English)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="abstract_english"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.abstract_english && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, abstract_english: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.abstract_english.name}</small>
        </>
      )}
    </div>
  </div>
</div>

<h3>Supplementary Documents</h3>
<div className="form-section">
  <div className="form-field file-upload">
    <label>Questionnaires (Lao)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="questionnaires_lao"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.questionnaires_lao && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, questionnaires_lao: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.questionnaires_lao.name}</small>
        </>
      )}
    </div>
  </div>

  <div className="form-field file-upload">
    <label>Questionnaires (English)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="questionnaires_english"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.questionnaires_english && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, questionnaires_english: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.questionnaires_english.name}</small>
        </>
      )}
    </div>
  </div>
</div>

<div className="form-section">
  <div className="form-field file-upload">
    <label>Information Sheet (Lao)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="information_sheet_lao"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.information_sheet_lao && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, information_sheet_lao: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.information_sheet_lao.name}</small>
        </>
      )}
    </div>
  </div>

  <div className="form-field file-upload">
    <label>Information Sheet (English)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="information_sheet_english"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.information_sheet_english && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, information_sheet_english: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.information_sheet_english.name}</small>
        </>
      )}
    </div>
  </div>
</div>

<div className="form-section">
  <div className="form-field file-upload">
    <label>Consent Form (Lao)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="consent_form_lao"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.consent_form_lao && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, consent_form_lao: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.consent_form_lao.name}</small>
        </>
      )}
    </div>
  </div>

  <div className="form-field file-upload">
    <label>Consent Form (English)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="consent_form_english"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.consent_form_english && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, consent_form_english: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.consent_form_english.name}</small>
        </>
      )}
    </div>
  </div>
</div>

<div className="form-section">
  <div className="form-field file-upload">
    <label>CVs (Lao)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="cvs_lao"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.cvs_lao && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, cvs_lao: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.cvs_lao.name}</small>
        </>
      )}
    </div>
  </div>

  <div className="form-field file-upload">
    <label>CVs (English)</label>
    <div className="file-input-wrapper">
      <input
        type="file"
        name="cvs_english"
        onChange={handleFileChange}
        accept=".pdf" required
      />
      {formData.cvs_english && (
        <>
          <button
            type="button"
            className="clear-button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, cvs_english: null }))
            }
          >
            ✕
          </button>
          <small className="file-name">{formData.cvs_english.name}</small>
        </>
      )}
    </div>
  </div>
</div>

<div className="form-field file-upload full-width">
  <label>Bill of Payment (PDF)</label>
  <div className="file-input-wrapper">
    <input
      type="file"
      name="bill_of_payment"
      onChange={handleFileChange}
      accept=".pdf" required
    />
    {formData.bill_of_payment && (
      <>
        <button
          type="button"
          className="clear-button"
          onClick={() =>
            setFormData((prev) => ({ ...prev, bill_of_payment: null }))
          }
        >
          ✕
        </button>
        <small className="file-name">{formData.bill_of_payment.name}</small>
      </>
    )}
  </div>
</div>
        <button type="submit" className="submit-button">
          Submit Proposal
        </button>
      </form>
    </div>
  );
};

export default ProposalSubmission;
